const STORAGE_KEY = 'kahveinn-theme';
const META_THEME_COLOR = { dark: '#101922', light: '#E6E9ED' };
const LABEL = { toLight: 'Açık temaya geç', toDark: 'Koyu temaya geç' };

let switchId = 0;

const isLight = () => document.documentElement.getAttribute('data-theme') === 'light';

export const getThemeToggleLabel = () => (isLight() ? LABEL.toDark : LABEL.toLight);

export const toggleTheme = () => {
    const root = document.documentElement;
    const nextLight = !isLight();
    const id = ++switchId;

    root.classList.add('theme-switching');
    if (nextLight) root.setAttribute('data-theme', 'light');
    else root.removeAttribute('data-theme');

    try {
        if (nextLight) localStorage.setItem(STORAGE_KEY, 'light');
        else localStorage.removeItem(STORAGE_KEY);
    } catch {}

    document.querySelector('meta[name="theme-color"]')
        ?.setAttribute('content', nextLight ? META_THEME_COLOR.light : META_THEME_COLOR.dark);

    const label = getThemeToggleLabel();
    document.querySelectorAll('[data-theme-toggle]').forEach(el => {
        el.setAttribute('aria-label', label);
        el.setAttribute('title', label);
    });

    // Art arda basışta yalnızca son geçiş class'ı kaldırır; aksi halde erken kalkan class transition'ları geri açar
    requestAnimationFrame(() => requestAnimationFrame(() => {
        if (id === switchId) root.classList.remove('theme-switching');
    }));
};
